"use client";

import React from "react";

export const SidebarNavBadge: React.FC<{ badge?: string | boolean }> = ({ badge }) => {
  if (!badge) return null;

  return (
    <span className="ml-auto inline-flex shrink-0 items-center rounded-full border border-cede-primary/20 bg-cede-primary/10 px-1 py-0.5 text-[7px] font-semibold uppercase tracking-wide leading-none text-cede-primary">
      {typeof badge === "string" ? badge : "NEW"}
    </span>
  );
};
